module.exports = __webpack_public_path__ + "static/cliente_3-51b6f2d86373e257772ffcabecf3572e.png";